module.exports = __webpack_public_path__ + "img/ic_high.7776f8af.svg";